import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { fetchForm } from 'b2b-apps/shop/content/redux/forms/actionCreators';
import { getFormElementsById } from 'b2b-apps/shop/content/redux/forms/selectors';

type UseFormElementsReturnType = RemoteRecord<any>;

const useFormElements = (formId: string): UseFormElementsReturnType => {
  const dispatch = useDispatch();
  const form = useSelector(
    useCallback((state: State) => getFormElementsById(state, formId), [formId]),
  );
  useEffect(
    (): void => {
      dispatch(fetchForm(formId));
    },
    [dispatch, formId],
  );

  return form;
};

export { useFormElements };
export type { UseFormElementsReturnType };
